var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("translates", {
    attrs: {
      item: this.product,
      item_id: parseInt(_vm.product.id),
      item_type: "product",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }